import { MagicConfigMixin, Throttle } from '@gig/magic-common';
import { Mixins, Watch, Component } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { USER_LOGGED_IN_UPDATED, CLEAR_REWARD_COUNT, REWARD_COUNT } from '@gig/magic-messages';
import { notificationService } from '@gig/magic-messaging';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let RewardPrompterComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.eventUnsub = null;
    this.userLoggedInSubscription = null;
    this.clearRewardCountSubscription = null;
    this.isLoading = false;
    this.rewardCount = 0;
  }
  created() {
    this.userLoggedInSubscription = window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, (event) => {
      this.onSessionChange(event.payload);
    }, { replay: true });
    this.clearRewardCountSubscription = window.commandBus.subscribe(CLEAR_REWARD_COUNT, () => {
      this.clearRewardCount();
    });
    this.showNewRewardNotification();
  }
  destroyed() {
    var _a;
    this.unsubscribe();
    (_a = this.userLoggedInSubscription) == null ? void 0 : _a.unsubscribe();
  }
  render() {
    return null;
  }
  onSessionChange(isLoggedIn) {
    if (!isLoggedIn) {
      this.unsubscribe();
      return;
    }
    this.fetchRewardCount();
    this.eventUnsub = magic.events.rewardReceived(() => this.fetchRewardCount()).unsub;
  }
  showNewRewardNotification() {
    this.rewardCount && notificationService.show(this.$t("new-reward-notification.text", {
      number: this.rewardCount
    }), {
      uniqueID: "new-reward-notification-text"
    });
  }
  unsubscribe() {
    var _a;
    if (!this.eventUnsub) {
      return;
    }
    (_a = this.clearRewardCountSubscription) == null ? void 0 : _a.unsubscribe();
    this.clearRewardCount();
    this.eventUnsub();
    this.eventUnsub = null;
  }
  fetchRewardCount() {
    return __async(this, null, function* () {
      if (this.isLoading) {
        return;
      }
      try {
        this.isLoading = true;
        const amount = yield magic.methods.rewards.newlyAwardedTokens();
        this.rewardCount = amount;
        window.eventBus.publish(REWARD_COUNT, amount);
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    });
  }
  clearRewardCount() {
    this.rewardCount = 0;
    window.eventBus.publish(REWARD_COUNT, 0);
  }
};
__decorateClass([
  Throttle(5e3),
  Watch("rewardCount")
], RewardPrompterComponent.prototype, "showNewRewardNotification", 1);
RewardPrompterComponent = __decorateClass([
  Component({
    name: "reward-prompter"
  })
], RewardPrompterComponent);

export { RewardPrompterComponent };
